export default "__VITE_ASSET__BEv7t83i__"